/**
 * CohortGrid — weekly user-retention heatmap (FEAT-ANALYTICS-002). Rows =
 * acquisition week, columns = weeks-since-acquisition, cells shaded by % retained.
 */
import React from 'react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, TableContainer } from '@chakra-ui/react';
import { fmtInt } from './components';

const shortDate = (d) => {
  const dt = new Date(String(d).replace(' ', 'T'));
  return isNaN(dt) ? String(d).slice(5) : dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export function CohortGrid({ cohort = [] }) {
  if (!cohort.length) return <Text fontSize="sm" color="gray.400" py={6} textAlign="center">No cohort data for this range</Text>;
  const nWeeks = cohort[0]?.cells?.length || 7;
  const cell = (pct) => {
    if (pct <= 0) return { bg: 'gray.50', color: 'gray.300' };
    const a = Math.min(0.1 + (pct / 100) * 0.85, 0.95);
    return { bg: `rgba(37,99,235,${a.toFixed(2)})`, color: pct > 45 ? 'white' : 'gray.700' };
  };
  return (
    <TableContainer>
      <Table size="sm" variant="unstyled" sx={{ 'td,th': { px: 2, py: 1.5, textAlign: 'center' } }}>
        <Thead>
          <Tr>
            <Th textAlign="left !important" color="gray.500" fontSize="10px">Cohort</Th>
            <Th color="gray.500" fontSize="10px">Users</Th>
            {Array.from({ length: nWeeks }).map((_, w) => <Th key={w} color="gray.500" fontSize="10px">Week {w}</Th>)}
          </Tr>
        </Thead>
        <Tbody>
          {cohort.map((row, i) => (
            <Tr key={i}>
              <Td textAlign="left !important" fontSize="12px" color="gray.600" whiteSpace="nowrap">{shortDate(row.cohort_week)}</Td>
              <Td fontSize="12px" fontWeight="600" color="gray.800">{fmtInt(row.size)}</Td>
              {row.cells.map((c, w) => {
                const st = cell(c.pct);
                return (
                  <Td key={w}>
                    <Box bg={st.bg} color={st.color} borderRadius="4px" fontSize="11px" fontWeight="600" py={1} sx={{ fontVariantNumeric: 'tabular-nums' }}>
                      {c.pct > 0 ? `${c.pct}%` : '–'}
                    </Box>
                  </Td>
                );
              })}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}

export default CohortGrid;
